export { NewHeaderComponent } from './NewHeaderComponent';
export { default as NewHeaderWrapper } from './NewHeaderWrapper';
